<template>
  <div v-if="mostrar" class="modal-overlay">
    <div class="modal-container">
      <div class="modal-header">
        <h6>Faltas Avisadas</h6>
        <i class="bi bi-x-circle close-icon" @click="emit('fechar')" title="Fechar" />
      </div>

      <div class="table-container">
        <table class="table table-striped mb-0">
          <thead>
            <tr>
              <th>Aluno</th>
              <th>Turma</th>
              <th>Data</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="!lista.length">
              <td colspan="3" class="text-center">
                Nenhuma falta avisada.
              </td>
            </tr>

            <tr v-for="item in lista" :key="item.id">
              <td>{{ item.aluno_nome }}</td>
              <td>{{ item.turma_completa }}</td>
              <td>{{ formatDate(item.data_aula) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, toRefs, computed } from 'vue'

const props = defineProps({
  mostrar: { type: Boolean, default: true },

  // ✅ Aceita os dois nomes pra não dar “vazio” por mismatch:
  aulas:   { type: Array, default: null },
  itens:   { type: Array, default: null }
})

const { mostrar, aulas, itens } = toRefs(props)
const emit = defineEmits(['fechar'])

const lista = computed(() => {
  // prioriza "aulas", senão cai para "itens"
  const a = Array.isArray(aulas.value) ? aulas.value : null
  const i = Array.isArray(itens.value) ? itens.value : null
  return a ?? i ?? []
})

function formatDate(d) {
  if (!d) return '—'
  // Aceita 'YYYY-MM-DD' ou ISO com 'T'
  if (typeof d === 'string' && d.includes('T')) {
    const dt = new Date(d)
    return isNaN(dt) ? d : dt.toLocaleDateString('pt-BR')
  }
  if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
    const [year, month, day] = d.split('-').map(Number)
    const date = new Date(year, month - 1, day)
    return isNaN(date) ? d : date.toLocaleDateString('pt-BR')
  }
  const date = d instanceof Date ? d : new Date(d)
  return isNaN(date) ? String(d) : date.toLocaleDateString('pt-BR')
}
</script>

<style scoped>
/* === COPIADO 1:1 do AulasReposicaoModal.vue === */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: #fff;
  width: 100%;
  max-width: 800px;
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 4px;
  z-index: 2001;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #f1f1f1;
  border-bottom: 1px solid #ddd;
}

.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}

.table-container {
  padding: 15px;
}

.table th,
.table td {
  vertical-align: middle;
}

/* Mantive os estilos “sobrando” do modal de reposição para ficar idêntico,
   mesmo que não tenha ações aqui. */
.action-icon {
  cursor: pointer;
  font-size: 1.2rem;
  color: #007bff;
}
.action-icon:hover {
  color: #0056b3;
}
</style>
